import React from 'react';
import PropTypes from 'prop-types';
import CounselorInfo from './CounselorInfo';

const ApplicationInterruptedAlert = ({ interruptedReason }) => {
  return (
    <div className="vads-u-margin-y--3">
      <va-alert
        close-btn-aria-label="Close notification"
        status="error"
        visible
      >
        <h2 slot="headline">
          Your VR&E Chapter 31 benefits have been interrupted
        </h2>
        <p>
          Your VR&E Chapter 31 benefits have been interrupted for the following
          reasons:
        </p>
        <ul>
          <li>{interruptedReason || 'No reason provided.'}</li>
        </ul>
        <p>If you need more information, contact your counselor.</p>
        <CounselorInfo showCard={false} />
      </va-alert>
    </div>
  );
};

ApplicationInterruptedAlert.propTypes = {
  interruptedReason: PropTypes.string,
  resCaseId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ApplicationInterruptedAlert;
